const makeInitialState = () => ({
  invoices: [null]
});

export default makeInitialState;
